import * as React from 'react';
import AdminUpgradeFeatures from 'admin/components/AdminUpgradeFeatures';
import AdminUpgradePlanQuoteBox from './AdminUpgradePlanQuoteBox';
import AdminUpgradePlanShareQuoteBanner from './AdminUpgradePlanShareQuoteBanner';
import Button from 'components/Button';
import Buttons from 'components/Buttons';
import EventTracking from 'lib/EventTracking';
import Row from 'components/Row';
import Text from 'components/Text';
import { UpgradePlanData, UpgradePlanQuote } from 'admin/components/AdminUpgradePlan/AdminUpgradePlanContainer';
import AdminUpgradeStatsContainer from 'admin/components/AdminUpgradeStats';
import { baseTrackingPrefix } from 'constants/SelfServeConstants';

import '../styles/AdminUpgradePlanQuoteForm.scss';
import ToastActions from 'actions/ToastActions';

type Props = {
  initialOrgUuid?: string;
  displayOrgStats?: boolean;
  quote: UpgradePlanQuote,
  taxExempt: boolean;
  onAdvance: () => void;
  onNoOrgStats: () => void;
  onContactSales: () => void;
  onTaxExemptChange: (taxExempt: boolean) => void;
  onPersistState: (fields: UpgradePlanData, quote: UpgradePlanQuote, onSuccess: Function) => void,
  purchaseSuccessful: boolean;
};

class AdminUpgradePlanQuoteForm extends React.Component<Props> {
  trackingPrefix = `${baseTrackingPrefix}.review_quote`;

  constructor(props: Props) {
    super(props);
    this.onContactSales = this.onContactSales.bind(this);
    this.onUpgradeNow = this.onUpgradeNow.bind(this);
  }

  componentDidMount() {
    this.track('view');
  }

  track = (key: string) => {
    EventTracking.trackKey(`${this.trackingPrefix}.${key}`);
  };

  handleTaxExemptChange = (taxExempt: boolean) => {
    this.track('tax_exempt.click');
    this.props.onTaxExemptChange(taxExempt);
  };

  showToast(text: string, kind: 'success' | 'error') {
    if (kind === 'success') {
      ToastActions.showSuccessToast(text);
    } else {
      ToastActions.showErrorToast(text);
    }
  }

  renderSidebar = () => {
    const { displayOrgStats, initialOrgUuid, onNoOrgStats } = this.props;

    return displayOrgStats && initialOrgUuid ? (
      <AdminUpgradeStatsContainer organizationUuid={initialOrgUuid} onNoStats={onNoOrgStats} />
    ) : (
      <AdminUpgradeFeatures />
    );
  }

  onUpgradeNow() {
    const { onPersistState, purchaseSuccessful, quote, onAdvance } = this.props;
    this.track('upgrade_now_button.click');

    onPersistState({ purchaseSuccessful }, quote, onAdvance)
  }

  onContactSales() {
    const { onPersistState, onContactSales, purchaseSuccessful, quote } = this.props;

    this.track('contact_sales_button.click');
    onPersistState({ purchaseSuccessful }, quote, onContactSales);
  }

  render() {
    const { quote, taxExempt } = this.props;

    return (
      <div className="AdminUpgradePlanQuoteForm">
        <div className="AdminUpgradePlanQuoteForm-content">
          <div className="AdminUpgradePlanQuoteForm-content-body">
            <div className="AdminUpgradePlanQuoteForm-content-body-forms">
              <Row>
                <Text weight="semibold" size="xlarge" element="div">
                  Your Remind plan quote
                </Text>
                <Text size="medium" element="div" color="thunder">
                  You’ll be able to review your order before completing your purchase.
                </Text>
              </Row>
              <Row size="small">{AdminUpgradePlanQuoteBox({quote, taxExempt, onTaxExemptChange: this.handleTaxExemptChange})}</Row>
              <Row size="medium">
                <AdminUpgradePlanShareQuoteBanner
                  shareToken={quote.shareToken}
                  showToast={this.showToast}
                  orgName={quote.organization.name}
                  trackingPrefixProp={this.trackingPrefix}
                />
              </Row>
              <Buttons align="left">
                <Button onClick={this.onUpgradeNow}>
                  Upgrade now
                </Button>
                <Button level="secondary" onClick={this.onContactSales}>
                  Contact sales
                </Button>
              </Buttons>
            </div>
            <div className="AdminUpgradePlanQuoteForm-content-body--desktop-side">
              <Row size="xxxlarge">{this.renderSidebar()}</Row>
            </div>
          </div>
        </div>
        <div className="AdminUpgradePlanQuoteForm--mobile-bottom">
          <div className="AdminUpgradePlanQuoteForm-info-container">
            {this.renderSidebar()}
          </div>
        </div>
      </div>
    );
  }
}

export { AdminUpgradePlanQuoteForm };
export default AdminUpgradePlanQuoteForm;
